import React from 'react';
import styled from 'styled-components';

const configureBoxModelDimensionValues =
  (pxValue: string) =>
  ({ direction }: { direction: string }) =>
    direction === 'up' ? `0 0 ${pxValue}px` : `${pxValue}px 0 0`;

export const TooltipWrapper = styled.span`
  position: relative;
  display: inline-block;
  margin: ${configureBoxModelDimensionValues('-20')};
`;

export const HoverElement = styled(
  ({ children, className }: React.PropsWithChildren<{ className?: string }>) => {
    const classNames = ['tooltip-element', className].filter(Boolean).join(' ');
    return <span className={classNames}>{children}</span>;
  }
)`
  position: relative;
  -webkit-tap-highlight-color: transparent;
`;
